<div class="flex flex-col h-full min-h-0 w-full bg-[#05171C] font-inter relative overflow-hidden">
  <button type="button"
          class="absolute top-[14px] right-[14px] z-10 size-8 rounded-full bg-white/[0.16] border-none cursor-pointer flex items-center justify-center transition-colors hover:bg-white/[0.26]"
          mat-dialog-close
          aria-label="Close">
    <mat-icon svgIcon="close" class="!w-full !h-auto max-w-[10px] max-h-[10px] text-white"></mat-icon>
  </button>
  <div class="flex flex-col items-center flex-1 min-h-0 overflow-y-auto overscroll-y-contain py-[40px] px-[20px] lg:px-[60px] lg:py-[56px] gap-6">
    <div class="w-[140px] h-[140px] lg:w-[260px] lg:h-[260px] xl:w-[360px] xl:h-[360px] pointer-events-none rounded-full absolute left-[15px] lg:left-[30px] xl:left-[80px] top-[-40px] bg-[#D92E2E]/[0.05]"></div>
    <div class="flex items-center justify-center size-24 bg-[#D92E2E]/15 rounded-full">
      <div class="flex items-center justify-center size-16 bg-[#D92E2E] rounded-full select-none">
        <mat-icon svgIcon="icon-lock-filled" class="!w-full !h-full max-w-[30px] max-h-[30px] text-white"></mat-icon>
      </div>
    </div>

    <h2 class="!text-3xl !font-bold !text-white !text-center !leading-[44px]">
      Subscription expired
    </h2>

    <p class="max-w-[560px] w-full text-[14px] text-[#A1C4C7] text-center leading-[1.60]">
      Your {{ actualPricePlan()?.name }} plan has expired and your account balance reached zero. Top up to resume running AML reports, API access and provider rates.
    </p>

    <div class="flex flex-col items-start w-full px-5 py-4 gap-2 bg-white/[0.05] border border-white/[0.1] rounded-xl">
    <span class="text-[9px] font-bold text-[#66E6B3] tracking-[0.06em] uppercase leading-[11px]">
      Reactivating restores
    </span>

      @if (actualPricePlan()) {
        <ul class="flex flex-col gap-2 w-full">
          <li class="flex items-center gap-2 h-4">
            <mat-icon svgIcon="pricing-check-mark" class="!w-full !h-full max-w-[12px] max-h-[8px] text-[#66E5B2]"></mat-icon>
            <span class="text-sm text-white font-normal">AML reports across {{ actualPricePlan()?.enabledProviders?.length }} providers</span>
          </li>
          <li class="flex items-center gap-2 h-4">
            <mat-icon svgIcon="pricing-check-mark" class="!w-full !h-full max-w-[12px] max-h-[8px] text-[#66E5B2]"></mat-icon>
            <span class="text-sm text-white font-normal">Per-report rates locked at {{ priceRange() }} USDT</span>
          </li>
          <li class="flex items-center gap-2 h-4">
            <mat-icon svgIcon="pricing-check-mark" class="!w-full !h-full max-w-[12px] max-h-[8px] text-[#66E5B2]"></mat-icon>
            <span class="text-sm text-white font-normal">
            @if (activatedPlan()?.billingCycle === 'YEARLY') {
              {{ actualPricePlan()?.planPriceYearly | number:'1.2-2' }}USDT fresh balance + {{ complianceHours() }}h compliance support
            } @else {
              {{ actualPricePlan()?.planPriceMonthly | number:'1.2-2' }} USDT fresh balance
            }
          </span>
          </li>
          <li class="flex items-center gap-2 h-4">
            <mat-icon svgIcon="pricing-check-mark" class="!w-full !h-full max-w-[12px] max-h-[8px] text-[#66E5B2]"></mat-icon>
            <span class="text-sm text-white font-normal">Dedicated account manager + priority assist</span>
          </li>
        </ul>
      }
    </div>

    <div class="flex items-start gap-[10px]">

      <!-- <a (click)="matDialogRef.close()" [routerLink]="'/balance'" [queryParams]="{ tabIndex: 1 }" class="flex items-center justify-center min-h-[40px] px-[18px] border border-white/20 rounded-[10px] leading-[18px] text-[13px] font-semibold text-white transition hover:bg-white/5 active:scale-95">
        View invoices
      </a> -->
      <button (click)="reactivatePlan()" class="flex items-center justify-center min-h-[40px] px-2 min-w-[216px] bg-[#66E6B3] rounded-[10px] leading-[18px] text-[13px] font-bold text-[#022D35] transition hover:bg-[#52c99b] active:scale-95 gap-1.5">
        <mat-icon svgIcon="restore-icon" class="text-inherit !w-full !h-full max-w-[10px] max-h-[14px]"></mat-icon>
        <span>Reactivate {{ actualPricePlan()?.name }} plan</span>
        <mat-icon svgIcon="arrow-right-2" class="text-inherit !w-full !h-full max-w-[12px] max-h-[10px]"></mat-icon>
      </button>
    </div>
  </div>
</div>
